// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

export const systemName = 'MSPV';

// export const apiURL = 'http://mspvapi.sytes.net/';
// export const API_URL = 'http://api.mspv.local/';
// export const API_URL = 'http://api.1mspv.com/';
//export const API_URL = 'http://localhost/apps/uno_mspv/api-mspv/public/';
export const API_URL = 'http://api2.mspv.local/';

export const APIKEY_GOOGLE = 'AIzaSyBJNkTbbr-tiqFwDV-ul_NC9ElozeQb_fk';

export let lang = 'ES';
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
